import React from "react";
import "./ScheduleMeeting.css";
import Navbar from "./Navbar/Navbar";  // adjust path if needed
import Footer from "./Footer/Footer";  // adjust path if needed

const ScheduleMeeting = () => {
  return (
    <>
      {/* Navbar always on top */}
      <Navbar />

      <div className="schedule-meeting-container">
        <h2>Schedule a Meeting with IQapex</h2>
        <p>
          Book a time that works for you. You’ll receive a confirmation email with
          a Google Meet link. Notifications will also be sent to{" "}
          <b>contact@iqapexlabs.com</b>.
        </p>

        {/* Button to open your Google Calendar appointment page */}
        <a
          href="https://calendar.app.google/uH39gH5xwRH1wTRc8"
          target="_blank"
          rel="noopener noreferrer"
          className="schedule-btn"
        >
          Book Now
        </a>

        {/* Embed Calendar */}
        <div className="calendar-frame">
          <iframe
            src="https://calendar.app.google/uH39gH5xwRH1wTRc8"
            style={{ border: "0", width: "100%", height: "800px" }}
            frameBorder="0"
            title="Google Calendar Appointment"
          ></iframe>
        </div>
      </div>

      {/* Footer always at bottom */}
      <Footer />
    </>
  );
};

export default ScheduleMeeting;
